<template>
  <div class="files-page">
    <v-layout row align-center class="files-header">
      <v-btn
        outline
        small
        color="white"
        class="files-back ma-0 mr-3"
        @click="goBack"
      >
        <v-icon left small>mdi-arrow-left</v-icon>
        Back
      </v-btn>
      <div class="files-header-copy">
        <div class="files-header-title">
          Manage files from
          {{ source.charAt(0).toUpperCase() + source.slice(1) }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <div v-if="!loading && pages.length" class="files-header-meta">
        {{ pages.length }}
        {{ pages.length === 1 ? "page" : "pages" }}
      </div>
    </v-layout>

    <div
      v-if="!loading && accountSummaryItems.length"
      class="files-account-strip"
    >
      <div
        v-for="item in accountSummaryItems"
        :key="item.label"
        class="files-account-item"
      >
        <a
          v-if="item.link"
          :href="item.link"
          target="_blank"
          :title="item.title"
        >
          <div class="files-account-label">{{ item.label }}</div>
          <div class="files-account-value">
            {{ item.value
            }}<v-icon class="ml-1" color="success" small
              >mdi-open-in-new</v-icon
            >
          </div>
        </a>
        <div v-else>
          <div class="files-account-label">{{ item.label }}</div>
          <div class="files-account-value">{{ item.value }}</div>
        </div>
      </div>
    </div>

    <div class="files-body">
      <v-alert v-if="error" type="error" class="mb-3">
        {{ error }}
      </v-alert>

      <div v-if="loading" class="files-loading">
        <v-progress-circular
          indeterminate
          color="success"
          size="88"
          width="6"
        ></v-progress-circular>
        <div class="files-loading-text">Loading files</div>
      </div>

      <v-layout row wrap v-if="!loading">
        <v-flex xs12 md8 class="files-grid-col">
          <v-card class="files-grid-card">
            <DocumentSplitterPageGrid
              :pages="pages"
              :selected-keys="selectedKeys"
              @toggle="togglePage"
              @select-all="selectAll"
              @clear="clearSelection"
            />
          </v-card>
        </v-flex>
        <v-flex xs12 md4 class="files-panel-col">
          <DocumentSplitterSavePanel
            :students="uniqueStudents"
            :doc-types="docTypes"
            :selected-pages="selectedPages"
            :student-id.sync="studentId"
            :doc-type-id.sync="docTypeId"
            :file-name.sync="fileName"
            :saving="saving"
            :account-id="accountID"
            @save="save"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";
import DocumentSplitterPageGrid from "./DocumentSplitterPageGrid.vue";
import DocumentSplitterSavePanel from "./DocumentSplitterSavePanel.vue";

export default {
  name: "DocumentSplitter",
  components: {
    DocumentSplitterPageGrid: DocumentSplitterPageGrid,
    DocumentSplitterSavePanel: DocumentSplitterSavePanel,
  },
  data() {
    return {
      loading: false,
      saving: false,
      error: "",
      source: "",
      sourceId: 0,
      accountID: "",
      attachments: [],
      pages: [],
      selectedKeys: [],
      students: [],
      docTypes: [],
      studentId: "",
      docTypeId: "",
      fileName: "",
      objectUrls: [],
      initData: null,
    };
  },
  computed: {
    uniqueStudents() {
      var seen = {};
      var list = [];

      (this.students || []).forEach(function(student) {
        var id = (student.studentID || "").trim();
        if (!id || seen[id]) {
          return;
        }
        seen[id] = true;
        list.push(student);
      });

      return list;
    },
    selectedPages() {
      const selected = this.selectedKeys;
      // Sort by uploaded order
      //   const result = this.pages.filter((page) => {
      //     return selected.indexOf(page.key) !== -1;
      //   });
      // Sort by selected order
      const result = selected
        .map((key) => this.pages.find((page) => page.key === key))
        .filter(Boolean);
      return result;
    },
    accountSummaryItems() {
      var data = this.initData || {};
      var info = data.accountInfo || {};
      var reg = (data.registrationSeasonRegID || "").trim();
      var name = (info.name || "").trim();
      var hname = (info.hname || "").trim();
      var registrationStatus = (info.registrationStatus || "").trim();

      var missingRequirements = (this.docTypes || [])
        .filter((type) => {
          return type.isMissing;
        })
        .map((type) => {
          return type.docTypeID.trim();
        })
        .join(", ");

      var studentsCount =
        typeof info.students === "number"
          ? info.students
          : this.uniqueStudents.length;
      var homePhone = (info.homePhone || "").trim();
      var cellPhone = (info.cellPhone || "").trim();
      var emailAddress = (info.emailAddress || "").trim();
      var items = [];
      if (this.accountID) {
        items.push({
          label: "Account ID",
          value: this.accountID.toUpperCase(),
          link: `/account-view/${this.accountID}`,
          title: "Click to view account",
        });
      }
      if (name) {
        items.push({ label: "Name", value: name });
      }
      if (hname) {
        items.push({ label: "נאמען", value: hname });
      }
      if (studentsCount) {
        items.push({ label: "Students", value: studentsCount + 1 });
      }
      if (homePhone) {
        items.push({ label: "Home Phone", value: homePhone });
      }
      if (cellPhone) {
        items.push({ label: "Cell Phone", value: cellPhone });
      }
      if (emailAddress) {
        items.push({ label: "Email Address", value: emailAddress });
      }
      if (reg) {
        items.push({ label: "Reg Season", value: reg, changeable: true });
      }
      if (registrationStatus) {
        items.push({ label: "Status", value: registrationStatus });
      }
      if (missingRequirements) {
        items.push({ label: "Missing", value: missingRequirements });
      }

      return items;
    },
  },
  async created() {
    this.source = this.$route.params.source;
    this.sourceId = parseInt(this.$route.params.sourceId, 10);
    await this.load();
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    fileKind: function(file) {
      var name = ((file && file.fileName) || "").toLowerCase();
      var type = ((file && file.contentType) || "").toLowerCase();
      var ext = name.indexOf(".") !== -1 ? name.split(".").pop() : "";

      if (
        ext === "svg" ||
        ext === "webp" ||
        type.indexOf("image/svg") === 0 ||
        type.indexOf("image/webp") === 0
      ) {
        return "other";
      }
      if (
        type.indexOf("image/") === 0 ||
        ["jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff"].indexOf(ext) !== -1
      ) {
        return "image";
      }
      if (type === "application/pdf" || ext === "pdf") {
        return "pdf";
      }
      return "other";
    },
    getPdfPageCount(src) {
      return new Promise((resolve) => {
        try {
          var task = pdf.createLoadingTask(src);
          task.promise
            .then((doc) => {
              resolve(doc.numPages || 0);
            })
            .catch(() => {
              resolve(0);
            });
        } catch (e) {
          resolve(0);
        }
      });
    },

    async load() {
      if (!this.source || !this.sourceId) {
        return this.$notify({
          group: "notification",
          type: "error",
          text: "Missing source, source ID, or account ID.",
        });
      }

      const apiUrlMap = {
        email: `api/SplitFiles/GetEmailAttachments?emailID=${this.sourceId}`,
        fax: `api/SplitFiles/GetFaxAttachments?faxID=${this.sourceId}`,
      };

      const apiUrl = apiUrlMap[this.source];
      if (!apiUrl) {
        return this.$notify({
          group: "notification",
          type: "error",
          text: "Invalid source.",
        });
      }

      this.loading = true;
      this.error = "";
      this.pages = [];
      this.selectedKeys = [];

      try {
        const result = (await this.$http.get(apiUrl)) || [];
        this.attachments = result.attachments;

        if (
          this.source === "fax" &&
          this.attachments &&
          !this.attachments.length
        ) {
          this.attachments = [this.attachments];
        }

        if (this.attachments.length === 0) {
          this.loading = false;
          return this.$notify({
            group: "notification",
            type: "error",
            text: "No attachments found.",
          });
        }

        this.accountID = this.attachments[0].accountID;

        if (!this.accountID) {
          this.loading = false;
          return this.$notify({
            group: "notification",
            type: "error",
            text: `This ${this.source} is not linked to an account.`,
          });
        }

        var initData = await this.$http.get(
          `api/splitFiles/GetInitData?accountID=${this.accountID}`
        );

        this.initData = initData || {};
        this.students = initData.students || [];

        this.docTypes = initData.documentTypes || [];

        this.docTypes = this.docTypes.map((type) => {
          const registrationRequirements = this.initData.registrationRequirements.find(
            (req) => req.docTypeID.trim() === type.docTypeID.trim()
          );
          return {
            ...type,
            isMissing:
              registrationRequirements && !registrationRequirements.isCompleted
                ? true
                : false,
          };
        });

        var pages = [];
        var index = 1;

        for (var i = 0; i < this.attachments.length; i++) {
          var file = this.attachments[i];
          var kind = this.fileKind(file);
          if (kind !== "pdf" && kind !== "image") {
            continue;
          }

          var src = file.fileURL;

          var numPages = await this.getPdfPageCount(src);
          if (!numPages) {
            pages.push({
              key: file.id + "-1",
              index: index,
              attachmentId: file.id,
              fileName: file.fileName,
              fileURL: file.fileURL,
              pageNumber: 1,
              src: src,
              kind: kind === "image" ? "image" : "pdf",
              linkedDocument:
                result.linkedDocuments.find((d) =>
                  d.sourceDocumentID.includes(`${file.id}-1`)
                ) || null,
            });
            index += 1;
          } else {
            for (var p = 1; p <= numPages; p++) {
              pages.push({
                key: file.id + "-" + p,
                index: index,
                attachmentId: file.id,
                fileName: file.fileName,
                fileURL: file.fileURL,
                pageNumber: p,
                src: src,
                kind: "pdf",
                linkedDocument:
                  result.linkedDocuments.find((d) =>
                    d.sourceDocumentID.includes(`${file.id}-${p}`)
                  ) || null,
              });
              index += 1;
            }
          }
        }
        this.pages = pages;
      } catch (e) {}

      this.loading = false;
    },
    togglePage(page) {
      const next = this.selectedKeys.slice();
      const pos = next.indexOf(page.key);
      if (pos === -1) {
        next.push(page.key);
      } else {
        next.splice(pos, 1);
      }
      this.selectedKeys = next;
    },
    selectAll() {
      this.selectedKeys = this.pages.filter((page) => !page.linkedDocument).map((page) => {
        return page.key;
      });
    },
    clearSelection() {
      this.selectedKeys = [];
    },
    async save() {
      this.saving = true;
      this.error = "";

      try {
        await this.$http.post("api/splitFiles/save", {
          emailID: this.emailId,
          accountID: this.accountID,
          studentID: this.studentId || null,
          docTypeID: this.docTypeId,
          fileName: this.fileName + ".pdf",
          pages: this.selectedPages.map((page) => {
            return {
              attachmentId: page.attachmentId,
              pageNumber: page.pageNumber,
            };
          }),
          source: this.source,
        });

        this.$notify({
          group: "notification",
          type: "success",
          text: "Document saved.",
        });
        this.resetForm();
        this.load();
        this.clearSelection();
      } catch (e) {
        this.error =
          e && e.message ? e.message : "Could not save the document.";
      }

      this.saving = false;
    },
    resetForm() {
      this.studentId = "";
      this.docTypeId = "";
      this.fileName = "";
      this.selectedKeys = [];
    },
  },
};
</script>
<style>
.files-page {
  padding: 10px 16px;
  margin: 0 auto;
}

.files-header {
  background: #4caf50;
  color: #fff;
  padding: 10px 16px;
  min-height: 56px;
}

.files-back {
  border-color: rgba(255, 255, 255, 0.7) !important;
  color: #fff !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

.files-back:hover {
  background: rgba(255, 255, 255, 0.12) !important;
}

.files-header-copy {
  min-width: 0;
}

.files-header-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.files-header-meta {
  font-size: 12px;
  opacity: 0.9;
}

.files-header-meta {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  padding: 4px 10px;
  font-weight: 600;
}

.files-body {
  padding: 16px;
}

.files-account-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 16px 0;
}

.files-account-item {
  background: #f6faf6;
  border: 1px solid #dcefdc;
  border-radius: 8px;
  padding: 6px 10px;
  min-width: 120px;
  max-width: 100%;
}

.files-account-label {
  font-size: 11px;
  line-height: 1.2;
  text-transform: uppercase;
  color: #7b8f7c;
  font-weight: 600;
}

.files-account-value {
  margin-top: 2px;
  font-size: 13px;
  line-height: 1.3;
  color: #2e2e2e;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.files-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.files-loading-text {
  margin-top: 12px;
  color: #757575;
  font-size: 13px;
  font-weight: 500;
}

.files-grid-col {
  padding-right: 8px;
}

.files-panel-col {
  padding-left: 8px;
}

.files-grid-card {
  padding: 12px 12px 8px;
  border-radius: 8px !important;
}

@media (max-width: 960px) {
  .files-grid-col,
  .files-panel-col {
    padding-left: 0;
    padding-right: 0;
  }

  .files-panel-col {
    margin-top: 12px;
  }
}
</style>
